export const FAMILY_PREVIEW_EDITOR_CONFIG = {
  global: {
    image: {
      marginBottom: 7
    },
    text: {
      fontSize: 18
    },
    cluster: {
      nodeName: 'cluster',
      margin: 10
    },
    product: {
      nodeName: 'product'
    },
    polygonFill: 'red'
  },
  text: {
    align: 'center',
    fontSize: 14,
    fill: 'white'
  },
  rectangle: {
    nodeName: 'rectangle',
    fill: 'transparent',
    stroke: '#878787',
    strokeWidth: 1
  },
  canvasPositioningHelper: {
    cluster: {
      minimalStepSize: 8
    },
    product: {
      minimalStepSize: 10
    },
    alignmentLines: {
      nodeName: 'alignment-line',
      stroke: 'rgb(0, 161, 255)',
      strokeWidth: 1,
      dash: [4, 6]
    },
    equalDistanceIndicators: {
      nodeName: 'equal-distance',
      stroke: 'rgb(0, 161, 255)',
      strokeWidth: 1
    }
  },
  defaultFamilyName: 'Antenna System',
  fileName: {
    antennaSystem: 'ERS_Family_Antenna',
    indoor: 'ERS_Family_Indoor',
    massiveMIMO: 'ERS_Family_Massive_MIMO',
    mobileTransport: 'ERS_Family_Transport',
    ranConnect: 'ERS_Family_RAN_Connect',
    ranCompute: 'ERS_Family_RAN_Compute',
    remoteRadio: 'ERS_Family_Remote_Radio',
    siteSystem: 'ERS_Family_Site',
    streetOutdoor: 'ERS_Family_Street'
  },
  mimeImage: 'data:image/png;base64,',
  nodeName: {
    cluster: 'cluster',
    product: 'product'
  },
  families: {
    antennaSystem: 'Antenna System',
    indoor: 'Indoor',
    massiveMIMO: 'Massive MIMO',
    mobileTransport: 'Mobile Transport',
    ranConnect: 'RAN Connect',
    ranCompute: 'RAN Compute',
    remoteRadio: 'Remote Radio',
    siteSystem: 'Site System',
    streetOutdoor: 'Street & Outdoor'
  },
  clusters: {
    special: 'Special',
    multiBand: 'MultiBand',
    microwave: 'Microwave',
    optical: 'Optical',
    router: 'Router',
    radioGateway: 'RadioGateway',
    optimized: '_4G5GOptimized',
    allTechnologies: 'AllTechnologies2G5G',
    singleBand: 'SingleBandTdd',
    tripleSector: 'TripleSector',
    smallCell: 'SmallCellSolutions',
    zeroFootprint: 'ZeroFootprintSolution',
    wideBand: 'WideBandTdd',
    micro: 'Micro',
    dualBand: 'DualBandFdd',
    streetMiBand: 'StreetMidBandTdd',
    streetMmWave: 'StreetMmWave',
    multiOperator: 'MultiOperator',
    singleOperator: 'SingleOperator',
    enclosure: 'EnclosureAndPower',
    energy: 'EnergyStorage',
    integratedSite: 'IntegratedSiteSolutions',
    interleaved: 'InterleavedAir',
    mmWave: 'MmWave',
    singleBandFdd: 'SingleBandFdd',
    multiBandFdd: 'MultiBandTddFdd',
    tripleBand: 'TripleBandFdd',
    smallVenues: 'SmallVenues',
    midBand: 'MidBandTdd',
    mcn: 'MCN'
  },
  clusterName: {
    special: 'Special',
    multiBand: 'Multi-band',
    microwave: 'Microwave',
    optical: 'Optical',
    router: 'Router',
    radioGateway: 'CPRI Connect',
    optimized: '4G/5G optimized',
    allTechnologies: 'All technologies 2G-5G',
    singleBand: 'Single-band TDD',
    tripleSector: 'Triple-sector',
    smallCell: 'Small cell solutions',
    zeroFootprint: 'Zero Footprint Solution',
    wideBand: 'Wide-band TDD',
    micro: 'Micro',
    dualBand: 'Dual-band FDD',
    streetMiBand: 'Street mid-band TDD',
    streetMmWave: 'Street mmWave',
    multiOperator: 'Multi-operator',
    singleOperator: 'Single-operator',
    enclosure: 'Enclosure & Power',
    energy: 'Energy Storage',
    integratedSite: 'Integrated Site Solutions',
    interleaved: 'Interleaved AIR',
    mmWave: 'mmWave',
    singleBandFdd: 'Single-band FDD',
    multiBandFdd: 'Multi-band TDD/FDD',
    tripleBand: 'Triple-band FDD',
    smallVenues: 'Small venues',
    midBand: 'Mid-band TDD',
    mcn: 'MCN'
  }
};
